import { Form, Input } from "decorator-form";
import { ILayout } from "common/form/fields/layout/ILayoutType";
import { IFragmentLayoutConfig } from "../../../core/components/FragmentLayout";
import { FragmentProvider } from "core/components/FragmentProvider";
import * as displayFragments from "../fragments/article/displayFragments";
import * as itemContainerFragments from "../fragments/container/itemContainerFragments";
import * as generalFragments from "../fragments/generalFragments";
import * as parentContainerFragments from "../fragments/container/parentContainerFragments";
import InputType from "common/form/InputType";
import { IArticleParams } from "../entities/ArticleParams";
import ArticleParamsField from "./ArticleParamsField";
import * as filterFragments from "../fragments/filterFragments";

const containerFragmentsInput = FragmentProvider.getInput(
	parentContainerFragments
);
const generalFragmentsInput = FragmentProvider.getLayoutInput({
	...generalFragments,
	...filterFragments
});

const kbFragmentsInput = FragmentProvider.getLayoutInput({
	...displayFragments
});
const itemFragmentInput = FragmentProvider.getInput(itemContainerFragments);
@Form({ title: "New knopwledge base config" })
export default class KnowledgeBaseNewPanelConfig {
	@Input({ type: ArticleParamsField, title: "Filters" })
	public preselectedParams: IArticleParams;

	@Input({ type: InputType.CHECKBOX, title: "Include Page Params" })
	public includePageParams?: boolean;

	@Input({ type: generalFragmentsInput, title: "Main Layout" })
	public mainLayout: ILayout<IFragmentLayoutConfig>;

	@Input({ type: containerFragmentsInput, title: "Container Type" })
	public containerFragment: string;

	@Input({ type: itemFragmentInput, title: "Item Wrapper Type" })
	public itemFragment: string;

	@Input({
		type: kbFragmentsInput,
		title: "Article Layout"
	})
	public kbFragmentsLayout: ILayout<IFragmentLayoutConfig>;
}



// WEBPACK FOOTER //
// ./src/panels/knowledgebase/config/KnowledgeBaseNewPanelConfig.ts